import { useSelector } from 'react-redux';
import { RootState } from '../state/store';
import { CompanyModules, hasModule } from '../utils/auth/AuthorizationUtility';

interface ModuleProps {
  module?: CompanyModules;
}

export const useCompanyModules = ({ module }: ModuleProps) => {
  const modules = useSelector((state: RootState) => state.auth.modules);
  if (!module) {
    return modules;
  }
  return hasModule(modules, module);
};
